import React from 'react'
import { Container, Header, ContentContainer, Title } from './Styled'
import CSS from 'csstype';

type ShowCaseCardProps = {
    isColored: boolean
    Icon: React.ReactNode
    title: string
    Content: React.ReactNode
    onClick: () => void
    style?: CSS.Properties
    id?: string
}

export const ShowCaseCard: React.FunctionComponent<ShowCaseCardProps> = ({
    Icon,
    onClick, 
    title,
    Content,
    style,
    id
}) => {
    return (
        <Container id={id} style={{...style}} onClick={onClick}>
            <Header>{Icon}</Header>
            <ContentContainer>
                <Title>{title}</Title>
                {Content}
            </ContentContainer>
        </Container>
    )
}

export default ShowCaseCard